export default __webpack_public_path__ + "static/media/flareBottom.4a4d7e87.png";